export const FETCH_TASKS_PENDING = "tasks/fetchTasks/pending";
export const FETCH_TASKS_SUCCEEDED = "tasks/fetchTasks/succeeded";
export const FETCH_TASKS_FAILED = "tasks/fetchTasks/failed";
export const UPDATE_QUERY_PARAMS = "tasks/queryParams/update";
export const UPDATE_SORTING_PARAMS = "tasks/sortingParams/update";
export const INITIALIZE_FILTERS = "tasks/filters/initialize";
export const UPDATE_FILTERS = "tasks/filters/update";
export const RESET_FILTERS = "tasks/filters/reset";
